import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProgressSpinnerComponent {

  constructor() { }

}
